export const getCookieDomain = () =>
  window?.__session__?.settings?.cookie_domain ||
  location?.domain ||
  'wetransfer.com';
